import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { AnyCatcher } from "rxjs/internal/AnyCatcher";
import { environment } from "src/app/environments/environment";
export const SERVER_API_URL = environment.serverUrl;
const routes = {
    live: {
        liveRfpList: (id: any) => `${SERVER_API_URL}/api/v1/getLiveRfpOnDTVendorCondition/${id}`,
        vendorRfpDetail: () => `${SERVER_API_URL}/api/v1/getVendorRfpDetail`,
        getVendorRfp_Detail2: () => `${SERVER_API_URL}/api/v1/getVendorRfp_Detail2`,
        createRfpDetail: () => `${SERVER_API_URL}/api/v1/fillRfpDatabyVendor`,
        getAllLiveRfpByVendor:(id:any, status:any) => `${SERVER_API_URL}/api/v1/getClosedOrLiveRfpDataByVendorId/${id}/${status}`,
        saveAnsweranddocument:()=>  `${SERVER_API_URL}/api/v1/VendorDocsKyc`,
        getVendorKycandDocsApprover:()=>`${SERVER_API_URL}/api/v1/getVendorDocsForApproval`,
        saveApproveorRejectRFP:()=>`${SERVER_API_URL}/api/v1/creatworkFlowEmp`,
        checkApprovalStatus:()=>`${SERVER_API_URL}/api/v1/checkRfpApprovedOrReject`,
        updatevendorInterest:()=>`${SERVER_API_URL}/api/v1/updatevendorInterest`,
        getVendorInterest:()=>`${SERVER_API_URL}/api/v1/getVendorInterest`,
        getRfpQuotationDetailsByVendorId:()=>`${SERVER_API_URL}/api/v1/getRfpQuotationDetailsByVendorId`,
        getClosedRfpDataByVendorId:(id:any, status:any)=>`${SERVER_API_URL}/api/v1/getClosedRfpDataByVendorId/${id}/${status}`,
        getCreatedRfpDetails:(id:any, id1:any)=>`${SERVER_API_URL}/api/v1/getCreatedRfpDetails/${id}/${id1}`,
        
    }
}
@Injectable({
    providedIn: 'root'
})
export class ManageRfpService {
    constructor(private http: HttpClient) { }
    // --------------------------live RFP-------------------------

    liveRfpList(id: any): Observable<any> {
        return this.http.get<any>(routes.live.liveRfpList(id), { observe: 'response' });
    }
    vendorRfpDetail(data: any): Observable<any> {
        return this.http.post<any>(routes.live.vendorRfpDetail(), data, { observe: 'response' });
    }
    getVendorRfp_Detail2(data: any): Observable<any> {
        return this.http.post<any>(routes.live.getVendorRfp_Detail2(), data, { observe: 'response' });
    }
    rfpdetailCreate(data:any): Observable<any> {
        return this.http.post<any>(routes.live.createRfpDetail(), data, {observe: 'response'});
    }
    getAllRfpVendor(id: any, status:any): Observable<any> {
        return this.http.get<any>(routes.live.getAllLiveRfpByVendor(id, status), { observe: 'response' });
    }
    saveAnsweranddocument(data:any):Observable<any>{
        return this.http.post<any>(routes.live.saveAnsweranddocument(),data,{observe:'response'})
    }
    getVendorKycandDocsApprovers(data:any):Observable<any>{ 
        return this.http.post<any>(routes.live.getVendorKycandDocsApprover(),data,{observe:'response'})
    }
    saveApproveorRejectRFP(data:any):Observable<any>{
        return this.http.post<any>(routes.live.saveApproveorRejectRFP(),data,{observe:'response'})
    }
    checkApprovalStatus(data:any):Observable<any>{
        return this.http.post<any>(routes.live.checkApprovalStatus(),data,{observe:'response'});
    }
    updatevendorInterest(data:any):Observable<any>{
        return this.http.post<any>(routes.live.updatevendorInterest(),data,{observe:'response'});
    }
    getVendorInterest(data:any):Observable<any>{
        return this.http.post<any>(routes.live.getVendorInterest(),data,{observe:'response'});
    }
    getRfpQuotationDetailsByVendorId(data:any):Observable<any>{
        return this.http.post<any>(routes.live.getRfpQuotationDetailsByVendorId(),data,{observe:'response'});
    }
    getClosedRfpDataByVendorId(id:any,status:any):Observable<any>{
        return this.http.get<any>(routes.live.getClosedRfpDataByVendorId(id,status),{observe:'response'});
    }
    getCreatedRfpDetails(id:any,id1:any):Observable<any>{
        return this.http.get<any>(routes.live.getCreatedRfpDetails(id,id1),{observe:'response'});
    }
    
}